export enum INVOICE_DOC_TYPES {
  INVOICE_DOCUMENT = 'INVOICE DOCUMENT',
  POLICY_SCHEDULE_DOCUMENT = 'POLICY SCHEDULE DOCUMENT',
}
export enum INVOICE_STATUS_TYPES {
  DRAFT = 'DRAFT',
  PAYMENT_PENDING = 'PAYMENT_PENDING',
  PAYMENT_PENDING_PARTIALLY_PAID = 'PAYMENT_PENDING_PARTIALLY_PAID',
  PAYMENT_RECEIVED = 'PAYMENT_RECEIVED',
  PAYMENT_PENDING_OVERDUE = 'PAYMENT_PENDING_OVERDUE',
  PENDING_REFUND = 'PENDING_REFUND',
  REFUND_SETTLED_PARTIALLY = 'REFUND_SETTLED_PARTIALLY',
  REFUND_SETTLED = 'REFUND_SETTLED',
  // New Status
  SETTLED_TO_BROKER = 'SETTLED_TO_BROKER',
  SETTLED_TO_INSURER = 'SETTLED_TO_INSURER',
  SETTLED_TO_BROKER_PARTIAL = 'SETTLED_TO_BROKER_PARTIAL',
  SETTLED_TO_INSURER_PARTIAL = 'SETTLED_TO_INSURER_PARTIAL',
  SETTLED_TO_CUSTOMER = 'SETTLED_TO_CUSTOMER',
  SETTLED_TO_CUSTOMER_PARTIAL = 'SETTLED_TO_CUSTOMER_PARTIAL',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  REJECTED = 'REJECTED',
  RE_REQUESTED = 'RE_REQUESTED',
}

export enum INVOICE_FLOW {
  STANDARD_FLOW = 'S',
  NSTD_FLOW = 'N',
}

export enum INVOICE_MODE {
  EDIT = 'EDIT',
  CREATE = 'CREATE',
  VIEW = 'VIEW',
}

export enum INVOICES_PAYMENT_METHODS {
  CASH = 'CASH',
  CHEQUE = 'CHEQUE',
  CARD = 'CARD',
  BANK_TRANSFER = 'BANK TRANSFER',
  ADJUSTMENT = 'ADJUSTMENT',
  CREDIT_DEBIT_CARD = 'CREDIT DEBIT CARD',
}

export enum INVOICES_PAYMENT_DOC_TYPES {
  CASH_RECEIPT = 'CASH RECEIPT',
  CHEQUE_RECEIPT = 'CHEQUE RECEIPT',
  BANK_TRANSFER_RECEIPT = 'BANK TRANSFER RECEIPT',
  CREDIT_DEBIT_CARD_RECEIPT = 'CREDIT DEBIT CARD RECEIPT',
}

export enum TYPE_ENTRY {
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT',
}

export enum PO_TYPE {
  LOCAL = 'LOCAL',
  FRONTING = 'FRONTING',
}

export enum PAY_TO {
  BROKER = 'BROKER',
  INSURER = 'INSURER',
}

export enum INVOICE_FEES_REFERENCE {
  FEES = 'FEES',
}
export enum INVOICE_CLASS_REFERENCE {
  CLASS = 'CLASS',
}
export enum INVOICE_FEES_FIELD {
  NAME = 'NAME',
  CODE = 'CODE',
  IS_ENABLE = 'ISENABLE',
}

export enum INVOICE_TYPE {
  SVAT = 'svat_invoice',
  VAT = 'vat_invoice',
}

export enum INVOICE_CLASS_FIELD {
  NAME = 'NAME',
  CODE = 'CODE',
  IS_ENABLE = 'ISENABLE',
  IS_LIFE = 'ISLIFE',
}

export enum INVOICE_PAY_TO_TYPES {
  BROKER = 0,
  INSURER,
  INSURER_PREMIUM_FORWARD,
  CUSTOMER,
}

export enum SETTLEMENT_VALUE {
  YES = 'YES',
  NO = 'NO',
}

export enum INVOICEACTION {
  ACCEPT = 'accept',
  MODIFY = 'modify',
  REJECT = 'reject',
}
